import React, { useState } from 'react';
import { Tooltip, message as antMessage } from 'antd';
import {
  CopyOutlined,
  RedoOutlined,
  LikeOutlined,
  DislikeOutlined,
  ShareAltOutlined,
  CheckOutlined,
} from '@ant-design/icons';
import styles from '../../styles/chatV2.module.css';

const MessageActions = ({
  message,
  onRegenerate,
  onFeedback,
  onCopy,
  onShare,
}) => {
  const [copied, setCopied] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(message.content);
      setCopied(true);
      antMessage.success('Copied to clipboard');

      if (onCopy) onCopy(message);

      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      antMessage.error('Failed to copy');
    }
  };

  const handleFeedback = (type) => {
    setFeedback(type);
    if (onFeedback) onFeedback(message, type);
    antMessage.success(
      type === 'positive' ? 'Thanks for your feedback!' : 'Feedback recorded'
    );
  };

  const handleRegenerate = () => {
    if (onRegenerate) onRegenerate(message);
  };

  const handleShare = () => {
    if (onShare) onShare(message);
  };

  return (
    <div className={styles.messageActions}>
      {/* Copy */}
      <Tooltip title={copied ? 'Copied!' : 'Copy'}>
        <button
          className={styles.actionButton}
          onClick={handleCopy}
          aria-label="Copy message"
        >
          {copied ? (
            <CheckOutlined className={styles.actionIcon} />
          ) : (
            <CopyOutlined className={styles.actionIcon} />
          )}
        </button>
      </Tooltip>

      {/* Regenerate */}
      <Tooltip title="Regenerate response">
        <button
          className={styles.actionButton}
          onClick={handleRegenerate}
          aria-label="Regenerate response"
        >
          <RedoOutlined className={styles.actionIcon} />
        </button>
      </Tooltip>

      {/* Thumbs Up */}
      <Tooltip title="Good response">
        <button
          className={`${styles.actionButton} ${
            feedback === 'positive' ? styles.actionActive : ''
          }`}
          onClick={() => handleFeedback('positive')}
          aria-label="Like response"
        >
          <LikeOutlined className={styles.actionIcon} />
        </button>
      </Tooltip>

      {/* Thumbs Down */}
      <Tooltip title="Poor response">
        <button
          className={`${styles.actionButton} ${
            feedback === 'negative' ? styles.actionActive : ''
          }`}
          onClick={() => handleFeedback('negative')}
          aria-label="Dislike response"
        >
          <DislikeOutlined className={styles.actionIcon} />
        </button>
      </Tooltip>

      {/* Share */}
      <Tooltip title="Share conversation">
        <button
          className={styles.actionButton}
          onClick={handleShare}
          aria-label="Share message"
        >
          <ShareAltOutlined className={styles.actionIcon} />
        </button>
      </Tooltip>
    </div>
  );
};

export default MessageActions;
